import './HeroGallery.scss';

class HeroGallery {

  constructor(node) {
    this.node = node;
  }

  init() {
    //console.log();
  }

}

JSModules['HeroGallery'] = HeroGallery;
export default HeroGallery;
